import Client from './client';

export default class BaseApi {
    constructor(config = {}) {
        this.path = [];
    }

    makePath(path) {
        this.path = [];
        this.path.push(`${path}`);
    }

    async get(path, params = {}) {
        this.makePath(path);
        this.params = params;
        try {
            const instance = await Client.get(`/${this.path.join("/")}`, {params: this.params}).then(response => {
                return response.data.response.data;
            });
            return instance;
        } catch(err) {
            throw err
        }
    }
}
